import { getScaleTypeId } from './getScaleTypeId';
import { ScaleType } from './types';

export const itemIsEvaluative = (scaleId: number) =>
  getScaleTypeId(scaleId) === ScaleType.Evaluative;
